import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user_ip: '',
    },
    getters: {},
    mutations: {
        updateUserIp(state, val) {
            state.user_ip = val
        },
    },
    actions: {},
    modules: {}
})